import { FilterCheckbox, useOrderedCustomerMeetingPoints } from "@repo/ui";
import { hasItems, isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const BusinessUnitFilter = ({ actions, filters }: FilterItemsProps) => {
  const { data: storeList } = useOrderedCustomerMeetingPoints();

  return (
    <FilterListContainer id="business-unit-filter">
      {hasItems(storeList) &&
        storeList.map(([key, value]) => (
          <FilterCheckbox
            key={key}
            id={key}
            value={key}
            label={value}
            checked={isChecked(filters.businessUnit, key)}
            onCheckFilter={actions.setBusinessUnit}
          />
        ))}
    </FilterListContainer>
  );
};
